export default "__VITE_ASSET__67uF$Ib7__"